"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.userFragmentDependencies, fragments_1.userFragment];
const MUTATION = `
mutation logInFromDapp(
  $walletPublicKey: String!
  $dappAddress: String!
  $timestamp: Long!
  $signature: String!
) {
  logInFromDapp(dappLogInInput: {
    walletPublicKey: $walletPublicKey
    dappAddress: $dappAddress
    timestamp: $timestamp
  }, signature: $signature) {
    ...userFragment
  }
}
`.trim();
const logInFromDaoImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'logInFromDapp');
exports.default = logInFromDaoImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nSW5Gcm9tRGFwcEltcGwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvbXV0YXRpb25zL2xvZ0luRnJvbURhcHBJbXBsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNENBQXNFO0FBQ3RFLDJFQUc0QztBQU01QyxNQUFNLFlBQVksR0FBRyxDQUFDLEdBQUcsb0NBQXdCLEVBQUUsd0JBQVksQ0FBQyxDQUFDO0FBRWpFLE1BQU0sUUFBUSxHQUFHOzs7Ozs7Ozs7Ozs7Ozs7Q0FlaEIsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUVULE1BQU0sZ0JBQWdCLEdBQUcsSUFBQSxnQ0FBVyxFQUNsQyxJQUFBLHdDQUFtQixFQUFDLEdBQUcsWUFBWSxFQUFFLFFBQVEsQ0FBQyxFQUM5QyxlQUFlLENBQ2hCLENBQUM7QUFFRixrQkFBZSxnQkFBZ0IsQ0FBQyJ9